<template>
  <main-content-wrapper>
    <h1 class="account" v-if="!error">
      Pozdravljeni,
      <div v-if="name"><span>{{ name }} {{ lastname }}</span>, {{ company }}</div>
      <div v-if="!name && company">{{ company }}</div>
    </h1>
    <template v-if="!error">
      <v-tabs v-model="tabs" v-show="!loading">
        <v-tab href="#profil" @click="pushRouter({name:'account'})">
          Moj profil
        </v-tab>
        <v-tab href="#soglasja" @click="pushRouter({name:'account-consents'})">
          Soglasja
        </v-tab>
        <v-tab href="#varnost" @click="pushRouter({name:'account-security'})">
          Varnost
        </v-tab>
      </v-tabs>
      <empty-space/>
      <v-tabs-items v-model="tabs">
        <v-tab-item value="profil">
          <profile-tab v-if="!loading"/>
        </v-tab-item>
        <v-tab-item value="soglasja">
          <consents-tab v-if="!loading"/>
        </v-tab-item>
        <v-tab-item value="varnost">
          <security-tab v-if="!loading"/>
        </v-tab-item>
      </v-tabs-items>
      <div class="loader" v-if="loading">
        <empty-space/>
        <v-progress-circular :indeterminate="true" size="50"></v-progress-circular>
      </div>
    </template>
    <template v-if="error">
      <v-alert
        :value="true"
        type="error"
      >
        Pri pridobivanju vaših podatkov je prišlo do napake.
      </v-alert>
      <empty-space/>
      <p class="text-sm-center">
        <v-btn depressed @click="reload()" color="primary_action_small">Poskusi ponovno</v-btn>
      </p>
    </template>
  </main-content-wrapper>
</template>

<script>
import MainContentWrapper from '../components/MainContentWrapper'
import EmptySpace from '../components/EmptySpace'
import ProfileTab from '../components/account/ProfileTab'
import SecurityTab from '../components/account/SecurityTab'
import utils from '../store/utils'
import ConsentsTab from '../components/account/ConsentsTab'
import Vue from 'vue'
import router from '@/router'

export default {
  name: 'Account',
  data () {
    return {
      tabs: 'profil',
    }
  },
  components: { ConsentsTab, MainContentWrapper, EmptySpace, ProfileTab, SecurityTab },
  computed: {
    loading: utils.vuexBuildSetGet(this, 'profile', 'loading'),
    error: utils.vuexBuildSetGet(this, 'profile', 'error'),
    name: utils.vuexBuildSetGet(this, 'profile', 'user.personal.name'),
    lastname: utils.vuexBuildSetGet(this, 'profile', 'user.personal.surname'),
    company: utils.vuexBuildSetGet(this, 'profile', 'user.personal.company.name'),
    email: utils.vuexBuildSetGet(this, 'profile', 'user.email'),
  },
  mounted () {
    this.updateSelectedTab()
  },
  created () {
    this.$store.dispatch('profile/allAboutMe')
  },
  watch:{
    $route (to, from){
      this.updateSelectedTab();
    }
  },
  methods: {
    reload () {
      window.location.replace('/')
    },
    pushRouter (data) {
      router.push(data)
    },
    updateSelectedTab () {
      if (this.$route.name == 'account-security') {
        this.tabs = 'varnost'
      } else if (this.$route.name == 'account-consents') {
        this.tabs = 'soglasja'
      } else if (this.$route.name == 'account') {
        this.tabs = 'profil'
      }
    }
  }
}
</script>

<style scoped>
h1.account {
  text-align: left;
  font-weight: normal;
  line-height: 1.15em;
}

h1.account div, h1.account div span {
  font-size: 1.0em;
  font-weight: 800;
}

h1.account span {
  display: inline-block;
  text-transform: uppercase;
}

.loader {
  text-align: center;
}


</style>
